import { api } from "./client";

export interface Customer {
  id: number;
  eik: string;
  vat_number: string | null;
  company_name: string;
  city: string;
  address: string;
  mol: string | null;
  // Последното използвано „получило" лице за тази фирма. FE-то го
  // пред-попълва при следваща фактура; при upsert на BE празна стойност
  // НЕ трие текущото име, само ново непразно име го замества.
  last_received_by: string | null;
}

export interface CustomerLookupResult {
  eik: string;
  vat_number: string | null;
  company_name: string;
  city: string | null;
  address: string | null;
  mol: string | null;
  source: string;
}

export const searchCustomers = async (q?: string): Promise<Customer[]> => {
  const params = new URLSearchParams();
  if (q && q.trim()) params.append("q", q.trim());
  const qs = params.toString();
  const response = await api.get<Customer[]>(
    qs ? `/customers?${qs}` : "/customers",
  );
  return response.data;
};

export const lookupCustomerByEik = async (
  eik: string,
): Promise<CustomerLookupResult> => {
  const response = await api.get<CustomerLookupResult>(
    `/customers/lookup?eik=${encodeURIComponent(eik)}`,
  );
  return response.data;
};

